import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterFeatureSource,
  CharacterSheetInterface,
  SKILLS,
} from "@dndModels";

// import API from "../../../utilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import LoadingBox from "@components/input/LoadingBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import CharacterSensesButton from "@dndComponents/character/misc/CharacterSensesButton";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSenses({
  character,
  char_interface,
  disabled,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = () => {
    // console.log("Senses");
    setReloading(true);
  }

  // eslint-disable-next-line
  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  }, []);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  let passive_perception = 10 + char_interface.passive_bonuses.perception;
  let passive_investigation = 10 + char_interface.passive_bonuses.investigation;
  let passive_insight = 10 + char_interface.passive_bonuses.insight;
  let skill_finder = SKILLS.filter(o => o.name === "Perception");
  if (skill_finder.length === 1) {
    const skill = skill_finder[0];
    const { modifier } = char_util.skillModifier(char_interface, skill);
    if (modifier) {
      passive_perception += modifier;
    }
  }
  skill_finder = SKILLS.filter(o => o.name === "Investigation");
  if (skill_finder.length === 1) {
    const skill = skill_finder[0];
    const { modifier } = char_util.skillModifier(char_interface, skill);
    if (modifier) {
      passive_investigation += modifier;
    }
  }
  skill_finder = SKILLS.filter(o => o.name === "Insight");
  if (skill_finder.length === 1) {
    const skill = skill_finder[0];
    const { modifier } = char_util.skillModifier(char_interface, skill);
    if (modifier) {
      passive_insight += modifier;
    }
  }
  return (
    <Grid container spacing={0} direction="row" 
      className="curved_border bg_black_transp">
      <Grid
        size={{
          xs: 12
        }}>
        <CharacterSensesButton
          character={character}
          char_interface={char_interface}
          disabled={disabled}
        />
      </Grid>
      <Grid
        className="centered"
        style={{
          fontSize: "11px"
        }}
        size={{
          xs: 12
        }}>
        <div style={{ width: "245px" }}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <div className="curved_border" style={{
                  padding: "4px"
                }}>
                <Grid container spacing={0} direction="row" 
                  style={{ 
                    margin: "4px",
                    height: "25px" 
                  }}>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left",
                      lineHeight: "0.5"
                    }}>
                      {/* { proficient ? <RadioButtonChecked /> : <RadioButtonUnchecked /> } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left", 
                      lineHeight: "1.6" 
                    }}>
                      {/* { (proficient && expert) ? "x2" : "" } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 9
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      Passive Perception <span style={{ color: "gray", fontSize: "11px" }}>WIS</span>
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      { passive_perception }
                    </div>
                  </Grid>
                </Grid>
              </div> 
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <div className="curved_border" style={{
                  padding: "4px"
                }}>
                <Grid container spacing={0} direction="row" 
                  style={{ 
                    margin: "4px",
                    height: "25px" 
                  }}>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left",
                      lineHeight: "0.5"
                    }}>
                      {/* { proficient ? <RadioButtonChecked /> : <RadioButtonUnchecked /> } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left", 
                      lineHeight: "1.6" 
                    }}>
                      {/* { (proficient && expert) ? "x2" : "" } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 9
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      Passive Investigation <span style={{ color: "gray", fontSize: "11px" }}>INT</span>
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      { passive_investigation }
                    </div>
                  </Grid>
                </Grid>
              </div> 
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <div className="curved_border" style={{
                  padding: "4px"
                }}>
                <Grid container spacing={0} direction="row" 
                  style={{ 
                    margin: "4px",
                    height: "25px" 
                  }}>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left",
                      lineHeight: "0.5"
                    }}>
                      {/* { proficient ? <RadioButtonChecked /> : <RadioButtonUnchecked /> } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ 
                      float: "left", 
                      lineHeight: "1.6" 
                    }}>
                      {/* { (proficient && expert) ? "x2" : "" } */}
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 9
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      Passive Insight <span style={{ color: "gray", fontSize: "11px" }}>WIS</span>
                    </div>
                  </Grid>
                  <Grid
                    size={{
                      xs: 1
                    }}>
                    <div style={{ float: "left", lineHeight: "1.6" }}>
                      { passive_insight }
                    </div>
                  </Grid>
                </Grid>
              </div> 
            </Grid>
            { char_interface.senses.map((sense, key) => {
              return (
                <Grid
                  key={key}
                  size={{
                    xs: 12
                  }}>
                  <b><DisplayObjects type="sense" ids={[sense.sense_id]} />:</b>Out to { sense.range }feet
                                  </Grid>
              );
            })}
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}

